<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <!-- 헤더 -->
        <div class="card-header d-flex align-items-center justify-content-between pb-0">
          <h6 class="my-2 ps-4 fw-800">제조사 정보</h6>
        </div>

        <!-- 바디 -->
        <div class="pt-4 pb-4 d-flex justify-content-center">
          <div class="w-100 px-5">

            <!-- 기본 정보 -->
            <section class="card mb-4 border-0">
              <div class="card-header pb-0">
                <h6 class="mb-0">기본 정보</h6>
              </div>

              <div class="card-body">
                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="form-label">제조사명 <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" v-model.trim="form.name" :disabled="!canEdit" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-label">회사코드</label>
                    <input type="number" class="form-control" v-model.number="form.companyPrefix" :disabled="!canEdit" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-label">사업자번호</label>
                    <input type="text" class="form-control" v-model.trim="form.bizRegNo" :disabled="!canEdit" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-label">GLN</label>
                    <input type="text" class="form-control" v-model.trim="form.gln" :disabled="!canEdit" />
                  </div>

                  <div class="col-12">
                    <label class="form-label">주소</label>
                    <input type="text" class="form-control" v-model.trim="form.address" :disabled="!canEdit" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-label">연락처</label>
                    <input type="text" class="form-control" v-model.trim="form.contactInfo" :disabled="!canEdit" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-label">홈페이지</label>
                    <div class="d-flex gap-2">
                      <input type="url" class="form-control" v-model.trim="form.homepage" :disabled="!canEdit" />
                    </div>
                  </div>

                  <div class="col-md-12">
                    <label class="form-label">유튜브 홍보 URL</label>
                    <div class="d-flex gap-2">
                      <input type="url" class="form-control" v-model.trim="form.youtube" :disabled="!canEdit"/>
                    </div>
                  </div>
                </div>
              </div>
            </section>

           <!-- 로고 -->
          <section class="card mb-4 border-0">
            <div class="card-header pb-0">
              <h6 class="mb-0">로고</h6>
            </div>
            <div class="card-body">
              <div class="d-flex align-items-end gap-3 flex-wrap">
                <div class="logo-box d-flex align-items-center justify-content-center bg-light border position-relative thumb clickable">
                  <img
                    v-if="logoPreview || form.logoImg"
                    :src="logoPreview || form.logoImg"
                    class="w-100 h-100 object-fit-contain rounded"
                    @click="canEdit && $refs.logoInput.click()"
                    alt="logo"
                  />
                  <span v-else class="text-secondary">No Image</span>
                </div>
                <div v-if="canEdit">
                  <label class="form-label mb-1">로고 이미지</label>
                  <div class="d-flex gap-2 align-items-center flex-wrap">
                    <div class="input-group" style="max-width: 320px;">
                      <input type="text"
                            class="form-control"
                            :value="displayLogoName"
                            placeholder="선택된 파일 없음"
                            readonly />
                      <button type="button"
                              class="btn btn-outline-secondary mb-0"
                              @click="$refs.logoInput.click()">선택</button>
                    </div>

                    <input ref="logoInput"
                          type="file"
                          accept="image/*"
                          class="d-none"
                          @change="onSelectLogo" />
                    <soft-button variant="outline" color="secondary" @click="clearLogo" :min-width="80">제거</soft-button>
                    <small class="form-label mb-0 text-muted ms-1">PNG/JPG, 10MB 이하 권장</small>
                  </div>
                </div>
              </div>
            </div>
          </section>

            <!-- ✅ 배경 이미지 업로드 (로고 아래 추가) -->
            <section class="card mb-4 border-0">
              <div class="card-header pb-0">
                <h6 class="mb-0">배경이미지</h6>
              </div>
              <div class="card-body">

                <div class="bg-preview border rounded mb-2 overflow-hidden thumb clickable" @click="canEdit && $refs.bgInput.click()">
                  <img v-if="bgPreview || form.bgImg"
                      :src="bgPreview || form.bgImg"
                      alt="background"
                      class="w-100"
                      style="display:block; object-fit:cover; aspect-ratio: 16/3;" />
                  <div v-else class="d-flex align-items-center justify-content-center text-secondary" style="height: 245px;">
                    배경이미지를 선택해주세요
                  </div>
                </div>

                <div class="d-flex align-items-center gap-2 flex-wrap mt-3">
                  <!-- ✅ 파일명 표시 + 선택 버튼 -->
                  <div class="input-group" style="max-width: 360px;">
                    <input type="text"
                          class="form-control"
                          :value="displayBgName"
                          placeholder="선택된 파일 없음"
                          readonly />
                    <button type="button"
                            class="btn btn-outline-secondary mb-0"
                            @click="$refs.bgInput.click()">선택</button>
                  </div>

                  <!-- 숨김 file (기존 ref 그대로 사용) -->
                  <input ref="bgInput"
                        type="file"
                        accept="image/*"
                        class="d-none"
                        @change="onSelectBg" />
                  <soft-button variant="outline" color="secondary" @click="clearBg" :min-width="80">제거</soft-button>
                  <small class="form-label mb-0 text-muted ms-1">JPG/PNG, 1600×300 이상(가로형) 권장</small>
                </div>
              </div>
            </section>
            
            <section class="card mb-4 border-0">
              <div class="card-header pb-0">
                <h6 class="mb-0">위치정보</h6>
              </div>
              <div class="card-body">
                <div class="bg-preview border rounded mb-2 overflow-hidden" style="height: 400px;">
                  <map-picker
                        v-model="locationValue"
                        :center="mapCenter" 
                        :zoom="13"
                        :height="'400px'"
                      />
                </div>
                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="form-label text-muted">위도</label>
                    <input type="text" class="form-control" :value="form.lat || '-'" disabled />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label text-muted">경도</label>
                    <input type="text" class="form-control" :value="form.lng || '-'" disabled />
                  </div>
                </div>
              </div>
            </section>

            <!-- 액션 -->
            <div class="d-flex justify-content-end mt-5 mb-3 gap-2 px-2">
              <soft-button color="success" @click="save">저장</soft-button>
            </div>
          </div>
        </div>
        <!-- // body -->
      </div>
    </div>
  </div>
<SoftConfirm ref="confirm" />
</template>

<script>
import SoftConfirm from "@/components/SoftConfirm.vue";
import SoftButton from "@/components/SoftButton.vue";
import MapPicker from "@/components/map/mapPicker.vue";
import api from "@/api/api";

export default {
  name: "ManufacturerDetail",
  components: { SoftConfirm, SoftButton, MapPicker },
  inject: ['showLoading', 'hideLoading'],
  data() {
    return {
      form: {
        id: null,
        address: "",
        name: "",
        bizRegNo: "",
        contactInfo: "",
        companyPrefix: null,
        logoImg: "",
        grpId: null,
        homepage: "",
        gln: "",
        logoImg: "",    // 다운로드 URL
        logoName: "",   // 원본 파일명
        bgImg: "",      // 다운로드 URL
        bgName: "",     // 원본 파일명
        youtube: "",     
        lat: null,
        lng: null,
        createdAt: null,
        updatedAt: null,
      },
      logoPreview: "",
      bgPreview: "",        // 배경 미리보기
    };
  },
  computed: {
    mfId() {
      return this.$store.getters['UserStore/getMfId'];
    },
    userInfo() {
      return this.$store.getters["UserStore/getUserInfo"];
    },
    canEdit() {
      const role = this.userInfo?.groupNm;
      return role === "ROLE_ADMIN" || role === "ROLE_SYSTEM";
    },
    displayLogoName() {
      return (this.$refs.logoInput?.files?.[0]?.name) || this.form.logoName || "";
    },
    displayBgName() {
      return (this.$refs.bgInput?.files?.[0]?.name) || this.form.bgName || "";
    },
    mapCenter() {
      if (this.form.lat && this.form.lng) {
        return [Number(this.form.lat), Number(this.form.lng)];
      }
      const mfInfo = this.$store.getters["UserStore/getMfInfo"];
      if (mfInfo?.lat && mfInfo?.lng) {
        return [mfInfo.lat, mfInfo.lng];
      }
      return [35.8714354, 128.601445];
    },
    locationValue: {
      get() {
        if (this.form.lat != null && this.form.lng != null) {
          return [Number(this.form.lat), Number(this.form.lng)];
        }
        return null;
      },
      set(val) {
        if (Array.isArray(val) && val.length === 2) {
          this.form.lat = Number(val[0]).toFixed(5);
          this.form.lng = Number(val[1]).toFixed(5);
        } else {
          this.form.lat = null;
          this.form.lng = null;
        }
      }
    }
  },
  async mounted() {
    await this.fetchDetail();
  },
  methods: {
    async fetchDetail() {
      this.loading = true;
      try {
        const [res] = await Promise.all([
          api.get(`/manufacturer`, { params: { id: this.mfId } }),
          new Promise(r => setTimeout(r, 300))
        ]);

        const result = res.data?.result || {};
        const item   = result.manufacturer || {};
        const logo   = result.logoImg || null;
        const bg     = result.bgImg   || null;

        Object.assign(this.form, item);

        // ✅ 로고
        if (logo?.downloadUrl) {
          this.form.logoImg   = logo.downloadUrl;
          this.form.logoName  = logo.originalName;
        } else {
          this.form.logoImg   = "";
          this.form.logoName  = "";
        }

        // ✅ 배경
        if (bg?.downloadUrl) {
          this.form.bgImg     = bg.downloadUrl;
          this.form.bgName    = bg.originalName;
        } else {
          this.form.bgImg     = "";
          this.form.bgName    = "";
        }

      } catch (e) {
        console.log(e)
        this.toastError?.("상세 조회 중 오류가 발생했습니다.");
      } finally {
        this.loading = false;
      }
    },
    onSelectLogo(e) {
      if (!this.canEdit) return;
      const f = e.target.files?.[0];
      if (!f) return;
      if (f.size > 10 * 1024 * 1024) { this.toastError?.("이미지는 10MB 이하로 업로드하세요."); e.target.value=""; return; }
      if (!/^image\//.test(f.type))  { this.toastError?.("이미지 파일만 업로드 가능합니다."); e.target.value=""; return; }

      if (this.logoPreview && this.logoPreview.startsWith('blob:')) URL.revokeObjectURL(this.logoPreview);
      this.logoPreview = URL.createObjectURL(f);
      this.form.logoName = f.name; // 표시용 백업(서버 원본 없을 때 대비)
    },
    onSelectBg(e) {
      const f = e.target.files?.[0];
      if (!f) return;
      if (f.size > 10 * 1024 * 1024) { this.toastError?.("이미지는 10MB 이하로 업로드하세요."); e.target.value=""; return; }
      if (!/^image\//.test(f.type))  { this.toastError?.("이미지 파일만 업로드 가능합니다."); e.target.value=""; return; }

      if (this.bgPreview && this.bgPreview.startsWith('blob:')) URL.revokeObjectURL(this.bgPreview);
      this.bgPreview = URL.createObjectURL(f);
      this.form.bgName = f.name;
    },
    clearLogo() {
      if (!this.canEdit) return;
      if (this.logoPreview && this.logoPreview.startsWith('blob:')) URL.revokeObjectURL(this.logoPreview);
      this.logoPreview = "";
      this.form.logoImg = "";
      this.form.logoName = "";
      if (this.$refs.logoInput) this.$refs.logoInput.value = "";
    },
    clearBg() {
      if (this.bgPreview && this.bgPreview.startsWith('blob:')) URL.revokeObjectURL(this.bgPreview);
      this.bgPreview = "";
      this.form.bgImg = "";
      this.form.bgName = "";
      if (this.$refs.bgInput) this.$refs.bgInput.value = "";
    },
    buildFormData() {
      const fd = new FormData();
      fd.append("id", this.form.id ?? "");
      fd.append("name", this.form.name ?? "");
      fd.append("companyPrefix", this.form.companyPrefix ?? "");
      fd.append("bizRegNo", this.form.bizRegNo ?? "");
      fd.append("gln", this.form.gln ?? "");
      fd.append("address", this.form.address ?? "");
      fd.append("contactInfo", this.form.contactInfo ?? "");
      fd.append("homepage", this.form.homepage ?? "");
      fd.append("lat", this.form.lat ?? "");
      fd.append("lng", this.form.lng ?? "");
      fd.append("youtube", this.form.youtube ?? "");

      // 파일 추가
      if (this.$refs.logoInput?.files?.[0]) {
        fd.append("logoFile", this.$refs.logoInput.files[0]);
      }
      if (this.$refs.bgInput?.files?.[0]) {
        fd.append("bgFile", this.$refs.bgInput.files[0]);
      }
      return fd;
    },
    /** ✅ 저장 */
    async save() {
      if (!this.canEdit) return;
      if (!this.form.name?.trim()) {
        this.toastError?.("제조사명을 입력하세요.");
        return false;
      }

      const action = '수정';
      const ok = await this.$refs.confirm.open({
        title: `제조사정보 ${action}`,
        message: `${action} 하시겠습니까?`,
        confirmText: action,
        cancelText: "취소",
        confirmColor: "success",
      });
      if (!ok) return;

      const delay = (ms) => new Promise(r => setTimeout(r, ms));
      const started = performance.now();

      this.showLoading?.("저장중...");
      try {
        const fd = this.buildFormData();

        await api.put(`/manufacturer/${this.form.id}`, fd, {
          headers: { "Content-Type": "multipart/form-data" }
        });

        const elapsed = performance.now() - started;
        if (elapsed < 1000) await delay(1000 - elapsed);

        this.toastSuccess?.(`제조사 정보가 ${action}되었습니다.`);

        this.$router.push({
          name: "Manufacturer",
          query: { t: Date.now() } 
        });
      } catch (e) {
        console.error(e);
        this.toastError?.("저장 중 오류가 발생했습니다.");
      } finally {
        this.hideLoading?.();
      }
    }
  },
};
</script>

<style scoped>
.fw-800 { font-weight: 800; }
.card { border: 1px solid rgba(0,0,0,.06) !important; }
.logo-box {
  width: 160px;
  height: 160px;
  border-radius: 0.75rem;
}
.thumb {
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  will-change: transform;
  user-select: none;
}
.clickable { cursor: pointer; }
.clickable:hover { transform: scale(1.02); }
.clickable:active { transform: scale(0.99); }
</style>
